// extracted by mini-css-extract-plugin
export var chatHtmlText = "_uc-2";
export var chatLink = "_uc-0";
export var chatText = "_uc-1";